import * as system from "@/services/system";
// import MasterManagment from "@/services/master_mgmt/index";
// import DeviceManagement from "@/services/device_mgmt/index";

export default {
  ...system,
  // ...MasterManagment,
  // ...DeviceManagement,
};
